import { IS_DEMO_MODE } from '@/utils/demoMode';
import { UrlTrackingComponent } from './UrlTracking.component';
import { UrlTrackingDemoComponent } from './UrlTracking.demo.component';

export const UrlTrackingPage = IS_DEMO_MODE
  ? UrlTrackingDemoComponent
  : UrlTrackingComponent;
